module.exports = __webpack_public_path__ + "img/custom-branding-placeholder-icon.06a5df1b.svg";